// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ArrowDown from "@ces/XDL/Icons/ArrowDown";
import { xBaseTheme } from "@ces/XDL/types";
import { color } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            src: ArrowDown,
            css: css`
                color: ${color("text.link")};
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
        css: css`
            & ~ ${IconWrapper} {
                width: 9px;
                height: 13px;
                box-sizing: content-box;
                top: 50%;
                translate: 0px -47%;
                &:not(:disabled) {
                    pointer-events: none;
                }
            }
            &[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
            }
        `,
    },
} as xBaseTheme["select"];
